import { UserEnteredMaterialsDocument } from '~/gql/graphql'

import { productionLeadTimesQuery } from './TableCells/ProductionSpeedCell/logic'

export const createUserEnteredMaterialsQuery = () => ({
    query: UserEnteredMaterialsDocument,
})

export const createProductionLeadTimesQuery = (id: string) => ({
    query: productionLeadTimesQuery,
    variables: {
        id,
    },
})
